import CheckDevice from '../../Modules/CheckDevice.js';
import * as CustomProperty from '../../Modules/CustomProperty.js';
import Animation from '../../Modules/Animation.js';
import * as Accordion from '../../Modules/Accordion.js';
import DrawerMenu from '../../Modules/DrawerMenu.js';
import Modal from '../../Modules/Modal.js';
import * as UpdateStatus from '../../Modules/UpdateStatus.js';
import Slider from '../../Modules/Slider.js';
import * as CustomScroll from '../../Modules/CustomScroll.js';
import SmoothScroll from '../../Modules/SmoothScroll.js';
import ScrollBox from '../../Modules/ScrollBox.js';
import ScrollCopy from '../../Modules/ScrollCopy.js';
import Toggle from '../../Modules/Toggle.js';


const preinit = (e) => {
  UpdateStatus.load();
}

const init = () => {
  UpdateStatus.load();
  CheckDevice();
  CustomProperty.init();
  Slider();
  DrawerMenu.init();
  Modal.init();
  CustomScroll.init();
  SmoothScroll();
  ScrollCopy();
  Accordion.init();
  Toggle.init();
}

const resize = () => {
  UpdateStatus.resize();
  CheckDevice();
  CustomProperty.resize();
  CustomScroll.resize();
}

const resizeW = () => {
  CustomProperty.resizeW();
}

const scroll = () => {
  UpdateStatus.scroll();
  CustomProperty.scroll();
  Animation();
}

const load = () => {
  UpdateStatus.load();
  Animation();
  ScrollBox();
}

export {
  preinit,
  init,
  resize,
  resizeW,
  scroll,
  load
}